import { api } from './http';

// ========== ACC (Autodesk Construction Cloud) API Functions ==========

/**
 * ACC bağlantısını test et
 */
export const testAccConnection = async (): Promise<{ success: boolean; message?: string; token_available?: boolean; error?: string }> => {
  const response = await api.get('/acc/test');
  return response.data;
};

/**
 * ACC hub'larını listele
 */
export const getAccHubs = async (): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get('/acc/hubs');
  return response.data;
};

/**
 * ACC projelerini listele
 */
export const getAccProjects = async (accountId: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get('/acc/projects', {
    params: { account_id: accountId }
  });
  return response.data;
};

/**
 * Belirli bir projenin detaylarını getir
 */
export const getAccProjectDetails = async (projectId: string, hubId?: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}`, {
    params: hubId ? { hub_id: hubId } : undefined
  });
  return response.data;
};

/**
 * Proje klasörlerini listele
 */
export const getAccFolders = async (projectId: string, folderId: string = 'root', hubId?: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}/folders`, {
    params: hubId ? { folder_id: folderId, hub_id: hubId } : { folder_id: folderId }
  });
  return response.data;
};

/**
 * Proje öğelerini (dosyalar) listele
 */
export const getAccItems = async (projectId: string, folderId: string = 'root', hubId?: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}/items`, {
    params: hubId ? { folder_id: folderId, hub_id: hubId } : { folder_id: folderId }
  });
  return response.data;
};

/**
 * Belirli bir öğenin detaylarını getir
 */
export const getAccItemDetails = async (projectId: string, itemId: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}/items/${itemId}`);
  return response.data;
};

/**
 * Proje ana klasörlerini getir (Top Folders)
 */
export const getAccTopFolders = async (projectId: string, hubId?: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}/topFolders`, {
    params: hubId ? { hub_id: hubId } : undefined
  });
  return response.data;
};

/**
 * Klasör içeriğini getir (alt klasörler + dosyalar birlikte)
 */
export const getAccFolderContents = async (projectId: string, folderId: string, hubId?: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}/folders/${folderId}/contents`, {
    params: hubId ? { hub_id: hubId } : undefined
  });
  return response.data;
};

/**
 * Dosyanın URN'ini getir (Viewer için)
 */
export const getAccItemUrn = async (projectId: string, itemId: string): Promise<{ success: boolean; urn?: string; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}/items/${itemId}/urn`);
  return response.data;
};

/**
 * APS/Forge Viewer için access token al
 */
export const getAccViewerToken = async (): Promise<{ success: boolean; access_token?: string; expires_in?: number; error?: string }> => {
  const response = await api.get('/acc/auth/token');
  return response.data;
};

/**
 * Proje içinde dosya ve klasör ara
 */
export interface AccSearchResult {
  id: string;
  name: string;
  type: 'folder' | 'file';
  path: string;
  extension?: string;
  size?: number;
}

export const searchAccProject = async (
  projectId: string,
  query: string,
  hubId: string
): Promise<{ success: boolean; results?: AccSearchResult[]; total?: number; error?: string }> => {
  const response = await api.get(`/acc/projects/${projectId}/search`, {
    params: { q: query, hubId }
  });
  return response.data;
};

/**
 * ACC dosyalarını PDF olarak export et
 */
export const exportAccFilesToPdf = async (fileIds: string[], options?: {
  includeIssues?: boolean;
  includePhotos?: boolean;
}): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.post('/acc/files/export/pdf', {
    fileIds,
    includeIssues: options?.includeIssues || false,
    includePhotos: options?.includePhotos || false
  });
  return response.data;
};

/**
 * PDF export işleminin durumunu kontrol et
 */
export const getAccExportStatus = async (exportId: string): Promise<{ success: boolean; data?: any; error?: string }> => {
  const response = await api.get(`/acc/files/export/pdf/${exportId}`);
  return response.data;
};
